import { capitalize } from "@/helpers/utils";
import { DateTime } from "luxon";
import { FC } from "react";

interface IProps {
  date: string;
}

const PopCalendar: FC<IProps> = ({ date }) => (
  <div className="calendar">
    <span className="calendar-month">
      {capitalize(DateTime.fromISO(date).monthShort)}
    </span>
    <span className="calendar-day">{DateTime.fromISO(date).day}</span>
  </div>
);

export default PopCalendar;
